import { useRef, useState } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import EventDateCalendar from '@Components/Events/EventDateCalendar';
import EventListing from '@Components/Events/EventListing';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { eventCategory } from '@Components/Utilities/SandhillsConstants';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue, useRecoilState } from 'recoil';

const AlertPreferenceModal = loadable(() => import('@Components/Shared/Modals/AlertPreferenceModal'), true);
const BiddingAgreementModal = loadable(() => import('@Components/Shared/Modals/BiddingAgreementModal'), true);

const MemoEventListing = React.memo(EventListing);

const FeaturedSellerAuctionDate = (props) => {

    const MAX_DESCRIPTION_LENGTH = 100;
    const routes = useRecoilValue(atoms.routes);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const [currentUser, setCurrentUser] = useRecoilState(atoms.currentUser);

    const [showAllSellers, setShowAllSellers] = useState(false);

    const [biddingAgreementProps, setBiddingAgreementProps] = useState(null);
    const [showBiddingAgreementModal, setShowBiddingAgreementModal] = useState(false);
    const [showAlertPreferenceModal, setShowAlertPreferenceModal] = useState(false);
    const [notificationSettings, setNotificationSettings] = useState(null);

    const allSellersUpcomingRowRef = useRef(null);

    const parsedAuctionDate = new Date(props.AuctionDate);

    const [isLoading, setIsLoading] = useState(false);
    const [eventIDForAlertPreferenceModal, setEventIDForAlertPreferenceModal] = useState(0);
    const [eventCategoryIDForAlertPreferenceModal, setEventCategoryIDForAlertPreferenceModal] = useState(0);

    // Convert AuctionDate to desired format
    const formattedAuctionDate = parsedAuctionDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    const handleViewAllToggle = () => {
        setShowAllSellers(prev => !prev);
        $(allSellersUpcomingRowRef.current).slideToggle();
    }

    /* T&C */
    const toggleBiddingAgreementModal = (data) => {
        !showBiddingAgreementModal ? setBiddingAgreementProps(data) : setBiddingAgreementProps(null);
        setShowBiddingAgreementModal(!showBiddingAgreementModal);
    };

    /* ALERT PREFERENCES */
    const openAlertPreferenceModal = (eventID, eventCategoryID) => {
        if (!currentUser.IsAuthenticated) {
            window.location.href = routes.SSO;
        }

        if (eventID && eventID > 0) {
            setEventIDForAlertPreferenceModal(eventID);
        }

        let siteName = "";

        if (eventCategoryID && eventCategoryID > 0) {
            setEventCategoryIDForAlertPreferenceModal(eventCategoryID);
            siteName = eventCategoryID === eventCategory.onlineAuction ? "AuctionTime" : "EquipmentFacts";
        } 

        

        if (!isLoading) {
            setIsLoading(true);
            sandhillsRequest({
                url: routes.GetUserAuctionAlertPreferences,
                method: 'post',
                data: {
                    siteName: siteName 
                },
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then((data) => {
                setIsLoading(false);
                if (data) {
                    setNotificationSettings(data);
                    setShowAlertPreferenceModal(!showAlertPreferenceModal);
                }
            }).catch(() => {
                setIsLoading(false);
            });
        }
    };

    return (
        <div className="upcoming-table">
            <div className="upcoming-title">
                <h2>
                    <a href={props.UpcomingAuctionSingleDateURL}>{formattedAuctionDate}</a>
                    <div className="event-count">{props.ListingCount} <TranslationText tKey='sandhills.itemsonauction' /></div>
                </h2>
            </div>
            {props.WeeklySale.FeaturedSellers.length > 0 && 
                <div className="event-listing upcoming-weekly-event">
                    <div className="upcoming-weekly-event-date-container">
                        {props.WeeklySale.IsSaleToday &&
                            <div className='upcoming-weekly-event-status'>
                                <strong><i className='fas fa-rss' /></strong>
                                <strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.live' /></strong>
                            </div>}
                        <EventDateCalendar
                            DateIndex={parsedAuctionDate.getDate()}
                            MonthIndex={parsedAuctionDate.getMonth()}
                            StartTime={props.WeeklySale.StartTime}
                        />
                    </div>
                    <div class="upcoming-weekly-event-details">
                        <div className="upcoming-weekly-event-title">
                            <strong><a href={props.UpcomingAuctionSingleDateURL}>{props.WeeklySale.Title}</a></strong>
                        </div>
                        <div className="upcoming-weekly-event-countdown">
                            <TranslationText tKey='sandhills.lotsstartsellingat' replaceValues={[`<strong><span class='upcoming-weekly-event-countdown-text'>${props.WeeklySale.StartTime}</span></strong>`]} />
                        </div>
                        <div className="upcoming-weekly-event-row">
                            <h3><TranslationText tKey='sandhills.featuredsellers' />:</h3>
                            <ul>
                                {props.WeeklySale.FeaturedSellers.map((vmSeller) => {
                                    return (
                                        <li key={vmSeller.LinkURL}>
                                            <a href={vmSeller.LinkURL}>
                                                <div className="upcoming-seller">
                                                    <strong>{vmSeller.DealerDisplayName}</strong>
                                                    {vmSeller.DealerDisplayLocation}
                                                </div>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        {props.WeeklySale.Sellers.length > 0 && (
                            <div className="upcoming-weekly-event-more">
                                <div className="upcoming-weekly-event-row" ref={allSellersUpcomingRowRef}>
                                    <ul>
                                        {props.WeeklySale.Sellers.map((Seller) => {
                                            return (
                                                <li key={Seller.LinkURL}>
                                                    <a href={Seller.LinkURL}>
                                                        <div className="upcoming-seller">
                                                            <strong>{Seller.DealerDisplayName}</strong>
                                                            {Seller.DealerDisplayLocation}
                                                        </div>
                                                    </a>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <Button className="view-sellers" onClick={handleViewAllToggle}>
                                    <div className="seller-icon"><i className={`fas ${!showAllSellers ? "fa-plus" : "fa-minus"}`} aria-hidden="true"></i></div>
                                    <div className="seller-text"><strong><TranslationText tKey={!showAllSellers ? "sandhills.viewallsellers" : "sandhills.hidesellers"} /></strong></div>
                                </Button>
                            </div>
                        )}
                    </div>
                </div>}
            {props.StandaloneSales.length > 0 && 
                props.StandaloneSales.map((StandaloneEvent) => {
                    return (
                        <MemoEventListing
                            {...StandaloneEvent}
                            IsWatchList={false}
                            listings={[]}
                            ShowAuctionBranding={true}
                            IsRecommendedAuctionsSearch={false}
                            MaxDescriptionLength={MAX_DESCRIPTION_LENGTH}
                            openAlertPreferenceModal={openAlertPreferenceModal}
                            openBiddingAgreementModal={toggleBiddingAgreementModal}
                            HideTag={true}
                        />
                    );
                })
            }
            {(showAlertPreferenceModal && eventIDForAlertPreferenceModal) &&
                <AlertPreferenceModal
                    {...notificationSettings}
                    onClose={(e) => { setShowAlertPreferenceModal(false); }}
                    EventID={eventIDForAlertPreferenceModal}
                    EventCategoryID={eventCategoryIDForAlertPreferenceModal}
                />}

            {(showBiddingAgreementModal && biddingAgreementProps) &&
                <BiddingAgreementModal
                    {...biddingAgreementProps}
                    onClose={toggleBiddingAgreementModal}
                />}
            <Backdrop
                open={isLoading}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress />
            </Backdrop>
        </div>
    );
};

export default FeaturedSellerAuctionDate;
